import React from 'react';
import TeacherAvailabilityPage from '../domains/squads/components/TeacherAvailabilityPage';

const AvailabilityPage: React.FC = () => {
  return <TeacherAvailabilityPage />;
};

export default AvailabilityPage;


